import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayFieldsController from "../../../../UI/modules/fieldsDisplay/ModuleDisplayFieldsController";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import memberDummyImage from "../../../../../images/memberDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../../../images/memberStatusMember.jpg";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import { getFullName } from "../../../../../helpers/CommonHelper";
import ReactFancyBox from "react-fancybox";
import { FaUser } from "react-icons/fa6";
import { FaUserAlt } from "react-icons/fa";
const Item = ({
  item,
  handleCheckBoxClick,
  isCheck,
  moduleConfig,
  confirmAndDelete,
  confirmAndDisabled,
  confirmAndEnabled,
  customButtonsForItems,
}) => {
  const getCustomerStats = () => {
    let items = [];

    if (item?.subscriptionsCount) {
      items.push({
        text: "No. of Subscriptions",
        value: item?.subscriptionsCount,
        type: "number",
      });
    }

    if (item?.ordersCount) {
      items.push({
        text: "No. of Orders",
        value: item?.ordersCount,
        type: "number",
      });
    }

    if (item?.nationality) {
      items.push({
        text: "Nationality",
        value: item?.nationality,
        type: "text",
      });
    }

    if (item?.initiallyAccountCreatedFor) {
      items.push({
        text: "Account Created For",
        value: item?.initiallyAccountCreatedFor,
        type: "text",
      });
    }

    // if (item?.disclaimerAccepted) {
    //   items.push({
    //     text: "Disclaimer Accepted",
    //     value: item?.disclaimerAccepted,
    //     trueValue: "Yes",
    //     falseValue: "No",
    //     type: "boolean",
    //   });
    // }

    // if (item?.emailVerified) {
    //   items.push({
    //     text: "Email Verified",
    //     value: item?.emailVerified,
    //     trueValue: "Yes",
    //     falseValue: "No",
    //     type: "boolean",
    //   });
    // }

    if (item?.profileCompleted) {
      items.push({
        text: "Profile Completed",
        value: item?.profileCompleted,
        trueValue: "Yes",
        falseValue: "No",
        type: "boolean",
      });
    }

    if (item?.kidsCount) {
      items.push({
        text: "No. of Kids",
        value: item?.kidsCount,
        type: "number",
      });
    }

    return items;
  };
  return (
    <Card className="item mb-2 borderCream">
      <Card.Header className="ps-1 pe-2 py-0 ">
        <div className="card-tools endColumn mb-1 pt-1">
          <div>
            {" "}
            {item.status && (
              <span
                className={`badge fw-semibold rounded-pill shadow-sm me-1 px-2 ${
                  item.status === "1"
                    ? "bg-custom-4"
                    : item.status === "0"
                    ? "bg-custom-6"
                    : ""
                }`}
              >
                {item.status === "1" ? "Active" : "Inactive"}
              </span>
            )}
            {item?.createdAt && (
              <span className="badge badge-light me-1 text-dark">
                Profile Created On :{" "}
                <span className="text-secondary">
                  <ModuleDisplayDate value={item?.createdAt} />{" "}
                </span>
              </span>
            )}
          </div>

          <div className=" text-right me-xl-2  mt-1">
            <Link
              to={`/${moduleConfig.url}/${item._id}`}
              className="btn btn-outline-secondary  listingActionIcon"
              title={`View ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-eye"></i>
            </Link>
            {/* <Link
              to={`/${moduleConfig.url}/update/${item._id}`}
              className="btn btn-outline-secondary listingActionIcon"
              title={`Update ${moduleConfig.singleItemTitle}`}
            >
              <i className="fas fa-pencil-alt"></i>
            </Link>

            {(item.status === "1" || item.status === 1) && (
              <span
                title={`Disabled ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndDisabled(item._id)}
                className="btn btn-outline-secondary  listingActionIcon"
              >
                <i className="fas fa-ban"></i>
              </span>
            )}

            {(item.status === "0" || item.status === 0) && (
              <span
                title={`Enabled ${moduleConfig.singleItemTitle}`}
                onClick={() => confirmAndEnabled(item._id)}
                className="btn btn-outline-secondary listingActionIcon"
              >
                <i className="fas fa-undo"></i>
              </span>
            )}
            <span
              title={`Enabled ${moduleConfig.singleItemTitle}`}
              onClick={() => confirmAndDelete(item._id)}
              className="btn btn-outline-secondary listingActionIcon"
            >
              <i className="fas fa-trash"></i>
            </span> */}
          </div>
        </div>
        <Card.Title className="d-flex m-0 p-0">
          <div className="d-flex ImageSectionSpacing">
            <div className="ms-1 mt-1 me-2 fossilImage">
              {item.image ? (
                <ReactFancyBox
                  thumbnail={`${process.env.REACT_APP_BACKEND_URL}public/${item.image}`}
                  image={`${process.env.REACT_APP_BACKEND_URL}public/${item.image}`}
                  caption={`${item.firstName} ${item.lastName}`}
                />
              ) : (
                <FaUserAlt className="text-secondary fs-2 ms-1" />
              )}
            </div>

            <div className="d-flex flex-column align-items-start justify-content-center ms-1">
              <span className="m-0 text-bold text-red">
                {" "}
                 <span className="">
                  {item.firstName} {item.lastName}
                </span>
              </span>
              <span className="">
                <span className="text-custom-4 mt-1 small  text-bold">
                  <ModuleDisplayEmail value={item.email} /> ({" "}
                  <ModuleDisplayPhone value={item.mobile} />)
                </span>
              </span>
            </div>
          </div>
        </Card.Title>
      </Card.Header>
      <Card.Body className="px-1 py-0">
        <Row>
          <Col className="mt-1 mb-1 ">
            {/* <StatsListing heading="Cart" clickable items={getCart()} /> */}
            <StatsListing items={getCustomerStats()} />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Item;
